(function () {
  var MOBILE_QUERY = '(max-width: 989px)';

  function initSlider(el) {
    if (el.swiper) {
      el.swiper.update();
      return;
    }

    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 24,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true
      }
    });
  }

  function destroySlider(el) {
    if (!el.swiper) return;
    el.swiper.destroy(true, true);
  }

  function setupSlider(el) {
    if (el.dataset.warrantyFaqSliderReady === 'true') return;
    el.dataset.warrantyFaqSliderReady = 'true';

    var mq = window.matchMedia(MOBILE_QUERY);

    function handleChange(event) {
      if (event.matches) {
        requestAnimationFrame(function () {
          initSlider(el);
        });
      } else {
        destroySlider(el);
      }
    }

    if (mq.addEventListener) {
      mq.addEventListener('change', handleChange);
    } else {
      mq.addListener(handleChange);
    }

    if (mq.matches) {
      initSlider(el);
    }
  }

  function init() {
    document.querySelectorAll('[data-warranty-faq-slider]').forEach(setupSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
